<template>
  <div>
    <ListingLayout
      :is-loading="intervalLoading ? false : isLoading"
      show-date
      :meta="meta"
      :headers="_headers"
      :items="list"
      selected-product="cso"
      :product-options="productOptions"
      search-label="search"
      :vertical-scroll="false"
      @filterOption="onFiltersChange"
    >
      <template v-slot:actions="{ item }">
        <div
          class="open-link"
          @click="openDetailModal(item)"
        >
          <v-btn
            color="primary"
            small
          >
            <span>Invoice</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:charge_point_id="{ item }">
        <div>
          <span>{{ item.charge_point_id }}/{{ item.connector_id }}</span>
        </div>
      </template>

      <!-- <template v-slot:location_name="{ item }">
        <div>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.city_name }}
              </span>
            </template>
            <span>{{ item.location_name }}</span>
          </v-tooltip>
        </div>
      </template> -->

      <template v-slot:date="{ item }">
        <div>{{ item.started_at | formatDate("DD-MM-YYYY") }}</div>
      </template>
      <template v-slot:started_at="{ item }">
        <div>{{ item.started_at | formatTime }}</div>
      </template>

      <template v-slot:start_soc="{ item }">
        <div>
          <span v-if="item.start_soc || item.start_soc == '0'">
            {{ item.start_soc }}
          </span>
          <span v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >
                  N/A
                </span>
              </template>
              <span>Feature not supported in this charger model</span>
            </v-tooltip>
          </span>
        </div>
      </template>

      <template v-slot:completed_at="{ item }">
        <div>{{ item.completed_at | formatTime }}</div>
      </template>

      <template #addFilters>
        <v-card>
          <v-select
            v-model="customFilters.location_id"
            filled
            dense
            clearable
            :items="locationsList"
            item-value="id"
            item-text="name"
            :label="$t('location')"
            @change="onChangeLocation"
          />
        </v-card>
        <v-card>
          <v-select
            v-model="customFilters.charge_point_id"
            filled
            dense
            clearable
            :items="chargersList"
            item-value="charge_point_id"
            item-text="charge_point_id"
            :label="$t('charge_point_id')"
            @change="fetchData"
          />
        </v-card>
        <v-card>
          <v-select
            v-model="customFilters.status"
            filled
            dense
            clearable
            :items="statusList"
            item-value="id"
            item-text="name"
            :label="$t('status')"
            @change="fetchData"
          />
        </v-card>
      </template>
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <template #actionModals>
        <!-- <edit-md-make v-if="editModal" :is-visible-dialog="editModal" :toggle-edit="toggleEditModal"
          :md-make="selectedRow" /> -->
        <Modal
          :is-visible="isDetail"
          :is-view="true"
          :toggle="openDetailModal"
          :title="$t('charging_session_detail')"
          width="800px"
        >
          <charging-session-detail
            v-if="selectedRow"
            :selected-row="selectedRow"
          />
        </Modal>
      </template>
    </ListingLayout>
    <!-- <Modal v-if="showModal" :is-visible="showModal" is-view :toggle="() => (showModal = false)">
      <edit-customer :customer-data="customerData" />

    </Modal> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";

// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () =>
      import("../../../../components/base/RefreshButton.vue"),
    Modal: () => import("@/components/Modals/Modal.vue"),
    ChargingSessionDetail: () => import("./dialogs/ChargingSessionDetails.vue"),
  },
  mixins: [ListingLayoutMixins],
  data() {
    return {
      intervalLoading: false,

      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      filters: {},
      customFilters: {},
      statusList: [
        {
          id: "in-progress",
          name: "In-Progress",
        },
        {
          id: "completed",
          name: "Completed",
        },
      ],
      showModal: false,
      isMounted: false,
      customerData: {},
      interval: null,

      //
      isDetail: false,
      selectedRow: null,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsChargingSession/getLoading",
      meta: "csmsChargingSession/getMeta",
      list: "csmsChargingSession/getList",
      locationsList: "csmsChargeStations/getLocation",
      chargersList: "csmsChargeStations/getChargers",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("charge_point_id"),
          align: "left",
          sortable: true,
          value: "charge_point_id",
        },
        {
          text: this.$t("vehicle"),
          align: "left",
          sortable: false,
          value: "vehicle_reg_no",
        },
        {
          text: this.$t("charging_location"),
          align: "left",
          sortable: false,
          value: "location_name",
        },
        {
          text: this.$t("city"),
          align: "left",
          sortable: false,
          value: "city_name",
        },

        {
          text: this.$t("date"),
          align: "left",
          sortable: true,
          value: "date",
        },
        {
          text: this.$t("start_time"),
          align: "left",
          sortable: true,
          value: "started_at",
        },

        {
          text: this.$t("end_time"),
          align: "left",
          sortable: true,
          value: "completed_at",
        },
        {
          text: this.$t("actions"),
          align: "left",
          sortable: true,
          value: "actions",
        },
      ];
      // computed headers for showing columns to role based
      return headers
        .filter(
          (header) =>
            header.showAdmin === undefined ||
            (header.showAdmin != undefined &&
              header.showAdmin === this.authUser.isAdmin)
        )
        .map((r) => ({ ...r, width: "5%" }));
    },
    currencySign() {
      return localStorage.getItem("selectedCurrency") || "";
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (val) {
        if (this.isMounted) {
          this.customFilters = {};
        }
        this.isMounted = true;
        if (val) {
          const params = { tenant_id: val };
          this.$store.dispatch("csmsChargeStations/LocationsList", params);
          // this.$store.dispatch("csmsChargeStations/chargerList", params);
        } else {
          // this.customFilters = {};
          this.$store.commit("csmsChargeStations/SET_LOCATION", []);
          // this.$store.commit("csmsChargeStations/SET_CHARGERS", []);
        }
      },
    },

    options() {
      this.fetchData();
    },
  },
  async mounted() {
    if (!this.authUser.isAdmin) {
      const params = { tenant_id: this.authUser.tenant_id };
      await this.$store.dispatch("csmsChargeStations/LocationsList", params);
    }
    this.$store.dispatch("csmsChargingSession/setLoadingValue", true);
    if (this.$route?.query?.location_id) {
      this.customFilters.location_id = parseInt(this.$route.query.location_id);
      const params = {
        tenant_id: parseInt(this.$route.query.tenant_id),
        location_id: this.customFilters.location_id,
      };
      this.$store.dispatch("csmsChargeStations/chargerList", params);
    }
    if (this.$route?.query?.status) {
      this.customFilters.status = this.$route.query.status;
    }
    if (this.$route?.query?.charge_point_id) {
      this.customFilters.charge_point_id = this.$route.query.charge_point_id;
    }
  },
  beforeDestroy() {
    this.$store.commit("csmsChargingSession/SET_LIST", []);
    clearTimeout(this.interval);
    const paramsSet = { ...this.options, ...this.customFilters };
    const params = {
      name: "billing_and_invoices",
      filters: paramsSet,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      clearTimeout(this.interval);
      const params = { ...this.options, ...this.customFilters };
      await this.$store.dispatch("csmsChargingSession/list", params);

      this.interval = setTimeout(() => {
        this.fetchByInterval();
      }, 30000);
    },
    async fetchByInterval() {
      this.intervalLoading = true;
      await this.fetchData();
      this.intervalLoading = false;
    },
    openDetailModal(val) {
      if (val) {
        this.selectedRow = val;
        this.isDetail = true;
      } else {
        this.isDetail = false;
        this.selectedRow = null;
        this.$store.commit("csmsChargingSession/SET_ENERGY_DATA", null);
      }
    },
    //
    onChangeLocation(v) {
      delete this.customFilters.charge_point_id;
      if (v) {
        const params = {
          tenant_id: this.options.tenant_id,
          location_id: v,
        };
        this.$store.dispatch("csmsChargeStations/chargerList", params);
      } else {
        this.$store.commit("csmsChargeStations/SET_CHARGERS", []);
      }
      this.fetchData();
    },
  },
};
</script>
<style lang="sass" scoped>
:deep .blue
  background-color: #d2e3fc !important
:deep .green
  color: #00b894 !important
  background-color: #e3fcef !important
:deep .yellow
  color: #afa018 !important
  background-color: #fffacd !important

.map-button
  height: 41px !important
  margin-right: 5px

.btn-disabled
  pointer-events: none !important
  background-color: #8f8f8f !important

:deep .v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line):not(.v-text-field--outlined).v-input--dense .v-select__slot > input
  font-size: 0.875rem !important
</style>
